import { render, staticRenderFns } from "./room_stocks.vue?vue&type=template&id=eff5e8f4&scoped=true&"
import script from "./room_stocks.vue?vue&type=script&lang=js&"
export * from "./room_stocks.vue?vue&type=script&lang=js&"
import style0 from "./all_stocks.css?vue&type=style&index=0&id=eff5e8f4&prod&scoped=true&lang=css&"
import style1 from "./room_stocks.css?vue&type=style&index=1&id=eff5e8f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff5e8f4",
  null
  
)

export default component.exports